import imageDan3xl from "@assets/images/team/dan.jpg?webp&imagetools";
import imageDanXs from "@assets/images/team/dan.jpg?webp&w=640&imagetools";
import imageDanSm from "@assets/images/team/dan.jpg?webp&w=768&imagetools";
import imageDanMd from "@assets/images/team/dan.jpg?webp&w=1024&imagetools";
import imageDanLg from "@assets/images/team/dan.jpg?webp&w=1280&imagetools";
import imageDanXl from "@assets/images/team/dan.jpg?webp&w=1536&imagetools";
import imageDan2xl from "@assets/images/team/dan.jpg?webp&w=1920&imagetools";
import imageHanz3xl from "@assets/images/team/hanz.jpg?webp&imagetools";
import imageHanzXs from "@assets/images/team/hanz.jpg?webp&w=640&imagetools";
import imageHanzSm from "@assets/images/team/hanz.jpg?webp&w=768&imagetools";
import imageHanzMd from "@assets/images/team/hanz.jpg?webp&w=1024&imagetools";
import imageHanzLg from "@assets/images/team/hanz.jpg?webp&w=1280&imagetools";
import imageHanzXl from "@assets/images/team/hanz.jpg?webp&w=1536&imagetools";
import imageHanz2xl from "@assets/images/team/hanz.jpg?webp&w=1920&imagetools";
import imageJakub3xl from "@assets/images/team/jakub.jpg?webp&imagetools";
import imageJakubXs from "@assets/images/team/jakub.jpg?webp&w=640&imagetools";
import imageJakubSm from "@assets/images/team/jakub.jpg?webp&w=768&imagetools";
import imageJakubMd from "@assets/images/team/jakub.jpg?webp&w=1024&imagetools";
import imageJakubLg from "@assets/images/team/jakub.jpg?webp&w=1280&imagetools";
import imageJakubXl from "@assets/images/team/jakub.jpg?webp&w=1536&imagetools";
import imageJakub2xl from "@assets/images/team/jakub.jpg?webp&w=1920&imagetools";
import imageJan3xl from "@assets/images/team/jan.jpg?webp&imagetools";
import imageJanXs from "@assets/images/team/jan.jpg?webp&w=640&imagetools";
import imageJanSm from "@assets/images/team/jan.jpg?webp&w=768&imagetools";
import imageJanMd from "@assets/images/team/jan.jpg?webp&w=1024&imagetools";
import imageJanLg from "@assets/images/team/jan.jpg?webp&w=1280&imagetools";
import imageJanXl from "@assets/images/team/jan.jpg?webp&w=1536&imagetools";
import imageJan2xl from "@assets/images/team/jan.jpg?webp&w=1920&imagetools";
import imageKaterina3xl from "@assets/images/team/katerina.jpg?webp&imagetools";
import imageKaterinaXs from "@assets/images/team/katerina.jpg?webp&w=640&imagetools";
import imageKaterinaSm from "@assets/images/team/katerina.jpg?webp&w=768&imagetools";
import imageKaterinaMd from "@assets/images/team/katerina.jpg?webp&w=1024&imagetools";
import imageKaterinaLg from "@assets/images/team/katerina.jpg?webp&w=1280&imagetools";
import imageKaterinaXl from "@assets/images/team/katerina.jpg?webp&w=1536&imagetools";
import imageKaterina2xl from "@assets/images/team/katerina.jpg?webp&w=1920&imagetools";
import imageMarieK3xl from "@assets/images/team/marie-k.jpg?webp&imagetools";
import imageMarieKXs from "@assets/images/team/marie-k.jpg?webp&w=640&imagetools";
import imageMarieKSm from "@assets/images/team/marie-k.jpg?webp&w=768&imagetools";
import imageMarieKMd from "@assets/images/team/marie-k.jpg?webp&w=1024&imagetools";
import imageMarieKLg from "@assets/images/team/marie-k.jpg?webp&w=1280&imagetools";
import imageMarieKXl from "@assets/images/team/marie-k.jpg?webp&w=1536&imagetools";
import imageMarieK2xl from "@assets/images/team/marie-k.jpg?webp&w=1920&imagetools";
import imageMarie3xl from "@assets/images/team/marie.jpg?webp&imagetools";
import imageMarieXs from "@assets/images/team/marie.jpg?webp&w=640&imagetools";
import imageMarieSm from "@assets/images/team/marie.jpg?webp&w=768&imagetools";
import imageMarieMd from "@assets/images/team/marie.jpg?webp&w=1024&imagetools";
import imageMarieLg from "@assets/images/team/marie.jpg?webp&w=1280&imagetools";
import imageMarieXl from "@assets/images/team/marie.jpg?webp&w=1536&imagetools";
import imageMarie2xl from "@assets/images/team/marie.jpg?webp&w=1920&imagetools";
import imageOndrej3xl from "@assets/images/team/ondrej.jpg?webp&imagetools";
import imageOndrejXs from "@assets/images/team/ondrej.jpg?webp&w=640&imagetools";
import imageOndrejSm from "@assets/images/team/ondrej.jpg?webp&w=768&imagetools";
import imageOndrejMd from "@assets/images/team/ondrej.jpg?webp&w=1024&imagetools";
import imageOndrejLg from "@assets/images/team/ondrej.jpg?webp&w=1280&imagetools";
import imageOndrejXl from "@assets/images/team/ondrej.jpg?webp&w=1536&imagetools";
import imageOndrej2xl from "@assets/images/team/ondrej.jpg?webp&w=1920&imagetools";
import imagePetrH3xl from "@assets/images/team/petr-h.jpg?webp&imagetools";
import imagePetrHXs from "@assets/images/team/petr-h.jpg?webp&w=640&imagetools";
import imagePetrHSm from "@assets/images/team/petr-h.jpg?webp&w=768&imagetools";
import imagePetrHMd from "@assets/images/team/petr-h.jpg?webp&w=1024&imagetools";
import imagePetrHLg from "@assets/images/team/petr-h.jpg?webp&w=1280&imagetools";
import imagePetrHXl from "@assets/images/team/petr-h.jpg?webp&w=1536&imagetools";
import imagePetrH2xl from "@assets/images/team/petr-h.jpg?webp&w=1920&imagetools";
import imagePetr3xl from "@assets/images/team/petr.jpg?webp&imagetools";
import imagePetrXs from "@assets/images/team/petr.jpg?webp&w=640&imagetools";
import imagePetrSm from "@assets/images/team/petr.jpg?webp&w=768&imagetools";
import imagePetrMd from "@assets/images/team/petr.jpg?webp&w=1024&imagetools";
import imagePetrLg from "@assets/images/team/petr.jpg?webp&w=1280&imagetools";
import imagePetrXl from "@assets/images/team/petr.jpg?webp&w=1536&imagetools";
import imagePetr2xl from "@assets/images/team/petr.jpg?webp&w=1920&imagetools";
import imageSarka3xl from "@assets/images/team/sarka.jpg?webp&imagetools";
import imageSarkaXs from "@assets/images/team/sarka.jpg?webp&w=640&imagetools";
import imageSarkaSm from "@assets/images/team/sarka.jpg?webp&w=768&imagetools";
import imageSarkaMd from "@assets/images/team/sarka.jpg?webp&w=1024&imagetools";
import imageSarkaLg from "@assets/images/team/sarka.jpg?webp&w=1280&imagetools";
import imageSarkaXl from "@assets/images/team/sarka.jpg?webp&w=1536&imagetools";
import imageSarka2xl from "@assets/images/team/sarka.jpg?webp&w=1920&imagetools";
import imageSula3xl from "@assets/images/team/sula.jpg?webp&imagetools";
import imageSulaXs from "@assets/images/team/sula.jpg?webp&w=640&imagetools";
import imageSulaSm from "@assets/images/team/sula.jpg?webp&w=768&imagetools";
import imageSulaMd from "@assets/images/team/sula.jpg?webp&w=1024&imagetools";
import imageSulaLg from "@assets/images/team/sula.jpg?webp&w=1280&imagetools";
import imageSulaXl from "@assets/images/team/sula.jpg?webp&w=1536&imagetools";
import imageSula2xl from "@assets/images/team/sula.jpg?webp&w=1920&imagetools";
import imageSvet3xl from "@assets/images/team/svet.jpg?webp&imagetools";
import imageSvetXs from "@assets/images/team/svet.jpg?webp&w=640&imagetools";
import imageSvetSm from "@assets/images/team/svet.jpg?webp&w=768&imagetools";
import imageSvetMd from "@assets/images/team/svet.jpg?webp&w=1024&imagetools";
import imageSvetLg from "@assets/images/team/svet.jpg?webp&w=1280&imagetools";
import imageSvetXl from "@assets/images/team/svet.jpg?webp&w=1536&imagetools";
import imageSvet2xl from "@assets/images/team/svet.jpg?webp&w=1920&imagetools";
import imageTerka3xl from "@assets/images/team/terka.jpg?webp&imagetools";
import imageTerkaXs from "@assets/images/team/terka.jpg?webp&w=640&imagetools";
import imageTerkaSm from "@assets/images/team/terka.jpg?webp&w=768&imagetools";
import imageTerkaMd from "@assets/images/team/terka.jpg?webp&w=1024&imagetools";
import imageTerkaLg from "@assets/images/team/terka.jpg?webp&w=1280&imagetools";
import imageTerkaXl from "@assets/images/team/terka.jpg?webp&w=1536&imagetools";
import imageTerka2xl from "@assets/images/team/terka.jpg?webp&w=1920&imagetools";
import { Locale, type LocalizedString } from "@core/schema/Locale.js";
import type { SourceSetQuery } from "@core/schema/SourceSetQuery.js";
import { sameValueForEveryLocale } from "@core/utils/sameValueForEveryLocale.js";

export interface TeamMember {
	name: string;
	jobTitle: LocalizedString;
	image: Partial<Record<SourceSetQuery, string>> & { default: string };
}

export const teamMembers = {
	petr: {
		name: "Petr",
		jobTitle: sameValueForEveryLocale("Co-founder nl[[]] CEO & Head of coffee"),
		image: {
			default: imagePetrXs,
			">sm": imagePetrSm,
			">md": imagePetrMd,
			">lg": imagePetrLg,
			">xl": imagePetrXl,
			">2xl": imagePetr2xl,
			">3xl": imagePetr3xl,
		},
	},
	marie: {
		name: "Marie",
		jobTitle: sameValueForEveryLocale("Co-founder nl[[]] Products & Projects"),
		image: {
			default: imageMarieXs,
			">sm": imageMarieSm,
			">md": imageMarieMd,
			">lg": imageMarieLg,
			">xl": imageMarieXl,
			">2xl": imageMarie2xl,
			">3xl": imageMarie3xl,
		},
	},
	petrH: {
		name: "Petr",
		jobTitle: sameValueForEveryLocale("COO"),
		image: {
			default: imagePetrHXs,
			">sm": imagePetrHSm,
			">md": imagePetrHMd,
			">lg": imagePetrHLg,
			">xl": imagePetrHXl,
			">2xl": imagePetrH2xl,
			">3xl": imagePetrH3xl,
		},
	},
	ondrej: {
		name: "Ondřej",
		jobTitle: sameValueForEveryLocale("Head of wholesale"),
		image: {
			default: imageOndrejXs,
			">sm": imageOndrejSm,
			">md": imageOndrejMd,
			">lg": imageOndrejLg,
			">xl": imageOndrejXl,
			">2xl": imageOndrej2xl,
			">3xl": imageOndrej3xl,
		},
	},
	sarka: {
		name: "Šárka",
		jobTitle: sameValueForEveryLocale("Marketing & Content & Events"),
		image: {
			default: imageSarkaXs,
			">sm": imageSarkaSm,
			">md": imageSarkaMd,
			">lg": imageSarkaLg,
			">xl": imageSarkaXl,
			">2xl": imageSarka2xl,
			">3xl": imageSarka3xl,
		},
	},
	jan: {
		name: "Honza",
		jobTitle: {
			[Locale.cs]: "HR & administrativa",
			[Locale.en]: "HR & Administration",
		},
		image: {
			default: imageJanXs,
			">sm": imageJanSm,
			">md": imageJanMd,
			">lg": imageJanLg,
			">xl": imageJanXl,
			">2xl": imageJan2xl,
			">3xl": imageJan3xl,
		},
	},
	hanz: {
		name: "Honza",
		jobTitle: {
			[Locale.cs]: "Velkoobchod Praha, Brno",
			[Locale.en]: "Wholesale Prague, Brno",
		},
		image: {
			default: imageHanzXs,
			">sm": imageHanzSm,
			">md": imageHanzMd,
			">lg": imageHanzLg,
			">xl": imageHanzXl,
			">2xl": imageHanz2xl,
			">3xl": imageHanz3xl,
		},
	},
	terka: {
		name: "Terka",
		jobTitle: {
			[Locale.cs]: "Velkoobchod Morava",
			[Locale.en]: "Wholesale Moravia",
		},
		image: {
			default: imageTerkaXs,
			">sm": imageTerkaSm,
			">md": imageTerkaMd,
			">lg": imageTerkaLg,
			">xl": imageTerkaXl,
			">2xl": imageTerka2xl,
			">3xl": imageTerka3xl,
		},
	},
	marieK: {
		name: "Marie",
		jobTitle: {
			[Locale.cs]: "Mezinárodní velkoobchod",
			[Locale.en]: "International wholesale",
		},
		image: {
			default: imageMarieKXs,
			">sm": imageMarieKSm,
			">md": imageMarieKMd,
			">lg": imageMarieKLg,
			">xl": imageMarieKXl,
			">2xl": imageMarieK2xl,
			">3xl": imageMarieK3xl,
		},
	},
	katerina: {
		name: "Kateřina",
		jobTitle: {
			[Locale.cs]: "Coffee store a školení",
			[Locale.en]: "Coffee store & training",
		},
		image: {
			default: imageKaterinaXs,
			">sm": imageKaterinaSm,
			">md": imageKaterinaMd,
			">lg": imageKaterinaLg,
			">xl": imageKaterinaXl,
			">2xl": imageKaterina2xl,
			">3xl": imageKaterina3xl,
		},
	},
	sula: {
		name: "Sula",
		jobTitle: {
			[Locale.cs]: "Vedoucí provozu",
			[Locale.en]: "Operations manager",
		},
		image: {
			default: imageSulaXs,
			">sm": imageSulaSm,
			">md": imageSulaMd,
			">lg": imageSulaLg,
			">xl": imageSulaXl,
			">2xl": imageSula2xl,
			">3xl": imageSula3xl,
		},
	},
	svet: {
		name: "Svět",
		jobTitle: {
			[Locale.cs]: "Senior production roaster & školení",
			[Locale.en]: "Senior production roaster & training",
		},
		image: {
			default: imageSvetXs,
			">sm": imageSvetSm,
			">md": imageSvetMd,
			">lg": imageSvetLg,
			">xl": imageSvetXl,
			">2xl": imageSvet2xl,
			">3xl": imageSvet3xl,
		},
	},
	dan: {
		name: "Dan",
		jobTitle: sameValueForEveryLocale("Production roaster"),
		image: {
			default: imageDanXs,
			">sm": imageDanSm,
			">md": imageDanMd,
			">lg": imageDanLg,
			">xl": imageDanXl,
			">2xl": imageDan2xl,
			">3xl": imageDan3xl,
		},
	},
	jakub: {
		name: "Jakub",
		jobTitle: sameValueForEveryLocale("Junior production roaster"),
		image: {
			default: imageJakubXs,
			">sm": imageJakubSm,
			">md": imageJakubMd,
			">lg": imageJakubLg,
			">xl": imageJakubXl,
			">2xl": imageJakub2xl,
			">3xl": imageJakub3xl,
		},
	},
} satisfies Record<string, TeamMember>;
